function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ReactCrop = t(require("react")) : e.ReactCrop = t(e.React);
}(this, function (e) {
  return function () {
    "use strict";

    var t = {
      899: function _(t) {
        t.exports = e;
      }
    },
        n = {};

    function o(e) {
      var r = n[e];
      if (void 0 !== r) return r.exports;
      var i = n[e] = {
        exports: {}
      };
      return t[e](i, i.exports, o), i.exports;
    }

    o.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return o.d(t, {
        a: t
      }), t;
    }, o.d = function (e, t) {
      for (var n in t) {
        o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
          enumerable: !0,
          get: t[n]
        });
      }
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var r = {};
    return function () {
      o.r(r), o.d(r, {
        Component: function Component() {
          return u;
        },
        areCropsEqual: function areCropsEqual() {
          return h;
        },
        centerCrop: function centerCrop() {
          return d;
        },
        clamp: function clamp() {
          return a;
        },
        containCrop: function containCrop() {
          return p;
        },
        convertToPercentCrop: function convertToPercentCrop() {
          return c;
        },
        convertToPixelCrop: function convertToPixelCrop() {
          return l;
        },
        default: function _default() {
          return u;
        },
        defaultCrop: function defaultCrop() {
          return i;
        },
        makeAspectCrop: function makeAspectCrop() {
          return s;
        },
        nudgeCrop: function nudgeCrop() {
          return g;
        }
      });
      var e = o(899),
          t = o.n(e);

      function n(e) {
        var t,
            o,
            r = "";
        if ("string" == typeof e || "number" == typeof e) r += e;else if ("object" == _typeof(e)) if (Array.isArray(e)) for (t = 0; t < e.length; t++) {
          e[t] && (o = n(e[t])) && (r && (r += " "), r += o);
        } else for (t in e) {
          e[t] && (r && (r += " "), r += t);
        }
        return r;
      }

      var i = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        unit: "px"
      };

      function a(e, t, n) {
        return Math.min(Math.max(e, t), n);
      }

      function h(e, t) {
        return e.width === t.width && e.height === t.height && e.x === t.x && e.y === t.y && e.unit === t.unit;
      }

      function s(e, t, n, o) {
        var r = l(e, n, o);
        return e.width && (r.height = r.width / t), e.height && (r.width = r.height * t), r.y + r.height > o && (r.height = o - r.y, r.width = r.height * t), r.x + r.width > n && (r.width = n - r.x, r.height = r.width / t), "%" === e.unit ? c(r, n, o) : r;
      }

      function d(e, t, n) {
        var o = l(e, t, n);
        return o.x = (t - o.width) / 2, o.y = (n - o.height) / 2, "%" === e.unit ? c(o, t, n) : o;
      }

      function c(e, t, n) {
        return "%" === e.unit ? _objectSpread(_objectSpread(_objectSpread({}, i), e), {}, {
          unit: "%"
        }) : {
          unit: "%",
          x: e.x ? e.x / t * 100 : 0,
          y: e.y ? e.y / n * 100 : 0,
          width: e.width ? e.width / t * 100 : 0,
          height: e.height ? e.height / n * 100 : 0
        };
      }

      function l(e, t, n) {
        return e.unit ? "px" === e.unit ? _objectSpread(_objectSpread(_objectSpread({}, i), e), {}, {
          unit: "px"
        }) : {
          unit: "px",
          x: e.x ? e.x * t / 100 : 0,
          y: e.y ? e.y * n / 100 : 0,
          width: e.width ? e.width * t / 100 : 0,
          height: e.height ? e.height * n / 100 : 0
        } : _objectSpread(_objectSpread(_objectSpread({}, i), e), {}, {
          unit: "px"
        });
      }

      function p(e, t, n, o, r) {
        var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
        var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
        var h = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : o;
        var s = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : r;

        var d = _objectSpread({}, e);

        var c = Math.min(i, o),
            l = Math.min(a, r),
            p = Math.min(h, o),
            g = Math.min(s, r);
        t && (t > 1 ? (c = a ? a * t : c, l = c / t, p = h * t) : (l = i ? i / t : l, c = l * t, g = s / t)), d.y < 0 && (d.height = Math.max(d.height + d.y, l), d.y = 0), d.x < 0 && (d.width = Math.max(d.width + d.x, c), d.x = 0);
        var w = o - (d.x + d.width);
        w < 0 && (d.x = Math.min(d.x, o - c), d.width += w);
        var u = r - (d.y + d.height);

        if (u < 0 && (d.y = Math.min(d.y, r - l), d.height += u), d.width < c && ("sw" !== n && "nw" != n || (d.x -= c - d.width), d.width = c), d.height < l && ("nw" !== n && "ne" != n || (d.y -= l - d.height), d.height = l), d.width > p && ("sw" !== n && "nw" != n || (d.x -= p - d.width), d.width = p), d.height > g && ("nw" !== n && "ne" != n || (d.y -= g - d.height), d.height = g), t) {
          var _e = d.width / d.height;

          if (_e < t) {
            var _e2 = Math.max(d.width / t, l);

            "nw" !== n && "ne" != n || (d.y -= _e2 - d.height), d.height = _e2;
          } else if (_e > t) {
            var _e3 = Math.max(d.height * t, c);

            "sw" !== n && "nw" != n || (d.x -= _e3 - d.width), d.width = _e3;
          }
        }

        return d;
      }

      function g(e, t, n, o) {
        var r = _objectSpread({}, e);

        return "ArrowLeft" === t ? "nw" === o ? (r.x -= n, r.y -= n, r.width += n, r.height += n) : "w" === o ? (r.x -= n, r.width += n) : "sw" === o ? (r.x -= n, r.width += n, r.height += n) : "ne" === o ? (r.y += n, r.width -= n, r.height -= n) : "e" === o ? r.width -= n : "se" === o && (r.width -= n, r.height -= n) : "ArrowRight" === t && ("nw" === o ? (r.x += n, r.y += n, r.width -= n, r.height -= n) : "w" === o ? (r.x += n, r.width -= n) : "sw" === o ? (r.x += n, r.width -= n, r.height -= n) : "ne" === o ? (r.y -= n, r.width += n, r.height += n) : "e" === o ? r.width += n : "se" === o && (r.width += n, r.height += n)), "ArrowUp" === t ? "nw" === o ? (r.x -= n, r.y -= n, r.width += n, r.height += n) : "n" === o ? (r.y -= n, r.height += n) : "ne" === o ? (r.y -= n, r.width += n, r.height += n) : "sw" === o ? (r.x += n, r.width -= n, r.height -= n) : "s" === o ? r.height -= n : "se" === o && (r.width -= n, r.height -= n) : "ArrowDown" === t && ("nw" === o ? (r.x += n, r.y += n, r.width -= n, r.height -= n) : "n" === o ? (r.y += n, r.height -= n) : "ne" === o ? (r.y += n, r.width -= n, r.height -= n) : "sw" === o ? (r.x -= n, r.width += n, r.height += n) : "s" === o ? r.height += n : "se" === o && (r.width += n, r.height += n)), r;
      }

      var w = {
        capture: !0,
        passive: !1
      };

      var u = /*#__PURE__*/function (_e$PureComponent) {
        _inherits(u, _e$PureComponent);

        var _super = _createSuper(u);

        function u() {
          var _this;

          _classCallCheck(this, u);

          _this = _super.apply(this, arguments), _this.docMoveBound = !1, _this.mouseDownOnCrop = !1, _this.dragStarted = !1, _this.evData = {
            startClientX: 0,
            startClientY: 0,
            startCropX: 0,
            startCropY: 0,
            clientX: 0,
            clientY: 0,
            isResize: !0
          }, _this.componentRef = (0, e.createRef)(), _this.mediaRef = (0, e.createRef)(), _this.initChangeCalled = !1, _this.state = {
            cropIsActive: !1,
            newCropIsBeingDrawn: !1
          }, _this.onCropPointerDown = function (e) {
            var _this$props = _this.props,
                t = _this$props.crop,
                n = _this$props.disabled,
                o = _this.getBox();

            if (!t) return;
            var r = l(t, o.width, o.height);
            if (n) return;
            e.cancelable && e.preventDefault(), _this.bindDocMove(), _this.componentRef.current.focus({
              preventScroll: !0
            });
            var i = e.target.dataset.ord,
                a = Boolean(i);
            var h = e.clientX,
                s = e.clientY,
                d = r.x,
                c = r.y;

            if (i) {
              var _t = e.clientX - o.x,
                  _n = e.clientY - o.y;

              var _a = 0,
                  _l = 0;
              "ne" === i || "e" == i ? (_a = _t - (r.x + r.width), _l = _n - r.y, d = r.x, c = r.y + r.height) : "se" === i || "s" === i ? (_a = _t - (r.x + r.width), _l = _n - (r.y + r.height), d = r.x, c = r.y) : "sw" === i || "w" == i ? (_a = _t - r.x, _l = _n - (r.y + r.height), d = r.x + r.width, c = r.y) : "nw" !== i && "n" != i || (_a = _t - r.x, _l = _n - r.y, d = r.x + r.width, c = r.y + r.height), h = d + o.x + _a, s = c + o.y + _l;
            }

            _this.evData = {
              startClientX: h,
              startClientY: s,
              startCropX: d,
              startCropY: c,
              clientX: e.clientX,
              clientY: e.clientY,
              isResize: a,
              ord: i
            }, _this.mouseDownOnCrop = !0, _this.setState({
              cropIsActive: !0
            });
          }, _this.onComponentPointerDown = function (e) {
            var _this$props2 = _this.props,
                t = _this$props2.crop,
                n = _this$props2.disabled,
                o = _this$props2.locked,
                r = _this$props2.keepSelection,
                i = _this$props2.onChange,
                a = _this.getBox();

            if (n || o || r && t) return;
            e.cancelable && e.preventDefault(), _this.bindDocMove(), _this.componentRef.current.focus({
              preventScroll: !0
            });
            var h = e.clientX - a.x,
                s = e.clientY - a.y,
                d = {
              unit: "px",
              x: h,
              y: s,
              width: 0,
              height: 0
            };
            _this.evData = {
              startClientX: e.clientX,
              startClientY: e.clientY,
              startCropX: h,
              startCropY: s,
              clientX: e.clientX,
              clientY: e.clientY,
              isResize: !0
            }, _this.mouseDownOnCrop = !0, i(l(d, a.width, a.height), c(d, a.width, a.height)), _this.setState({
              cropIsActive: !0,
              newCropIsBeingDrawn: !0
            });
          }, _this.onDocPointerMove = function (e) {
            var _this$props3 = _this.props,
                t = _this$props3.crop,
                n = _this$props3.disabled,
                o = _this$props3.onChange,
                r = _this$props3.onDragStart,
                i = _this.getBox();

            if (n || !t || !_this.mouseDownOnCrop) return;
            e.cancelable && e.preventDefault(), _this.dragStarted || (_this.dragStarted = !0, r && r(e));

            var _assertThisInitialize = _assertThisInitialized(_this),
                a = _assertThisInitialize.evData;

            var s;
            a.clientX = e.clientX, a.clientY = e.clientY, s = a.isResize ? _this.resizeCrop() : _this.dragCrop(), h(t, s) || o(l(s, i.width, i.height), c(s, i.width, i.height));
          }, _this.onComponentKeyDown = function (e) {
            var _this$props4 = _this.props,
                t = _this$props4.crop,
                n = _this$props4.disabled,
                o = _this$props4.onChange,
                r = _this$props4.onComplete,
                i = _this.getBox();

            if (n) return;
            var h = e.key;
            var s = !1;
            if (!t) return;

            var d = _this.makePixelCrop(),
                p = (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) ? u.nudgeStepLarge : e.shiftKey ? u.nudgeStepMedium : u.nudgeStep;

            if ("ArrowLeft" === h ? (d.x -= p, s = !0) : "ArrowRight" === h ? (d.x += p, s = !0) : "ArrowUp" === h ? (d.y -= p, s = !0) : "ArrowDown" === h && (d.y += p, s = !0), s) {
              e.cancelable && e.preventDefault(), d.x = a(d.x, 0, i.width - d.width), d.y = a(d.y, 0, i.height - d.height);

              var _t2 = l(d, i.width, i.height),
                  _n2 = c(d, i.width, i.height);

              o(_t2, _n2), r && r(_t2, _n2);
            }
          }, _this.onHandlerKeyDown = function (e, t) {
            var _this$props5 = _this.props,
                _this$props5$aspect = _this$props5.aspect,
                n = _this$props5$aspect === void 0 ? 0 : _this$props5$aspect,
                o = _this$props5.crop,
                r = _this$props5.disabled,
                _this$props5$minWidth = _this$props5.minWidth,
                i = _this$props5$minWidth === void 0 ? 0 : _this$props5$minWidth,
                _this$props5$minHeigh = _this$props5.minHeight,
                a = _this$props5$minHeigh === void 0 ? 0 : _this$props5$minHeigh,
                s = _this$props5.maxWidth,
                d = _this$props5.maxHeight,
                w = _this$props5.onChange,
                m = _this$props5.onComplete,
                y = _this.getBox();

            if (r || !o) return;
            if ("ArrowUp" !== e.key && "ArrowDown" !== e.key && "ArrowLeft" !== e.key && "ArrowRight" !== e.key) return;
            e.stopPropagation(), e.preventDefault();
            var x = (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) ? u.nudgeStepLarge : e.shiftKey ? u.nudgeStepMedium : u.nudgeStep,
                C = p(g(l(o, y.width, y.height), e.key, x, t), n, t, y.width, y.height, i, a, s, d);

            if (!h(o, C)) {
              var _e4 = c(C, y.width, y.height);

              w(C, _e4), m && m(C, _e4);
            }
          }, _this.onDocPointerDone = function (e) {
            var _this$props6 = _this.props,
                t = _this$props6.crop,
                n = _this$props6.disabled,
                o = _this$props6.onComplete,
                r = _this$props6.onDragEnd,
                i = _this.getBox();

            _this.unbindDocMove(), !n && t && _this.mouseDownOnCrop && (_this.mouseDownOnCrop = !1, _this.dragStarted = !1, r && r(e), o && o(l(t, i.width, i.height), c(t, i.width, i.height)), _this.setState({
              cropIsActive: !1,
              newCropIsBeingDrawn: !1
            }));
          }, _this.onDragFocus = function (e) {
            var t;
            null === (t = _this.componentRef.current) || void 0 === t || t.scrollTo(0, 0);
          };
          return _this;
        }

        _createClass(u, [{
          key: "document",
          get: function get() {
            return document;
          }
        }, {
          key: "getBox",
          value: function getBox() {
            var e = this.mediaRef.current;
            if (!e) return {
              x: 0,
              y: 0,
              width: 0,
              height: 0
            };

            var _e$getBoundingClientR = e.getBoundingClientRect(),
                t = _e$getBoundingClientR.x,
                n = _e$getBoundingClientR.y,
                o = _e$getBoundingClientR.width,
                r = _e$getBoundingClientR.height;

            return {
              x: t,
              y: n,
              width: o,
              height: r
            };
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(e) {
            var _this$props7 = this.props,
                t = _this$props7.crop,
                n = _this$props7.onComplete;

            if (n && !e.crop && t) {
              var _this$getBox = this.getBox(),
                  _e5 = _this$getBox.width,
                  _o = _this$getBox.height;

              _e5 && _o && n(l(t, _e5, _o), c(t, _e5, _o));
            }
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.resizeObserver && this.resizeObserver.disconnect();
          }
        }, {
          key: "bindDocMove",
          value: function bindDocMove() {
            this.docMoveBound || (this.document.addEventListener("pointermove", this.onDocPointerMove, w), this.document.addEventListener("pointerup", this.onDocPointerDone, w), this.document.addEventListener("pointercancel", this.onDocPointerDone, w), this.docMoveBound = !0);
          }
        }, {
          key: "unbindDocMove",
          value: function unbindDocMove() {
            this.docMoveBound && (this.document.removeEventListener("pointermove", this.onDocPointerMove, w), this.document.removeEventListener("pointerup", this.onDocPointerDone, w), this.document.removeEventListener("pointercancel", this.onDocPointerDone, w), this.docMoveBound = !1);
          }
        }, {
          key: "getCropStyle",
          value: function getCropStyle() {
            var e = this.props.crop;
            if (e) return {
              top: "".concat(e.y).concat(e.unit),
              left: "".concat(e.x).concat(e.unit),
              width: "".concat(e.width).concat(e.unit),
              height: "".concat(e.height).concat(e.unit)
            };
          }
        }, {
          key: "dragCrop",
          value: function dragCrop() {
            var e = this.evData,
                t = this.getBox(),
                n = this.makePixelCrop(),
                o = e.clientX - e.startClientX,
                r = e.clientY - e.startClientY;
            return n.x = a(e.startCropX + o, 0, t.width - n.width), n.y = a(e.startCropY + r, 0, t.height - n.height), n;
          }
        }, {
          key: "getPointRegion",
          value: function getPointRegion(e) {
            var t = this.evData,
                n = t.clientX - e.x,
                o = t.clientY - e.y < t.startCropY;
            return n < t.startCropX ? o ? "nw" : "sw" : o ? "ne" : "se";
          }
        }, {
          key: "resizeCrop",
          value: function resizeCrop() {
            var e = this.evData,
                t = this.getBox(),
                _this$props8 = this.props,
                _this$props8$aspect = _this$props8.aspect,
                n = _this$props8$aspect === void 0 ? 0 : _this$props8$aspect,
                _this$props8$minWidth = _this$props8.minWidth,
                o = _this$props8$minWidth === void 0 ? 0 : _this$props8$minWidth,
                _this$props8$minHeigh = _this$props8.minHeight,
                r = _this$props8$minHeigh === void 0 ? 0 : _this$props8$minHeigh,
                i = _this$props8.maxWidth,
                a = _this$props8.maxHeight,
                h = this.getPointRegion(t),
                s = this.makePixelCrop(),
                d = e.ord ? e.ord : h,
                c = e.clientX - e.startClientX,
                l = e.clientY - e.startClientY,
                g = {
              unit: "px",
              x: 0,
              y: 0,
              width: 0,
              height: 0
            };
            "ne" === h ? (g.x = e.startCropX, g.width = c, n ? (g.height = g.width / n, g.y = e.startCropY - g.height) : (g.height = Math.abs(l), g.y = e.startCropY - g.height)) : "se" === h ? (g.x = e.startCropX, g.y = e.startCropY, g.width = c, g.height = n ? g.width / n : l) : "sw" === h ? (g.x = e.startCropX + c, g.y = e.startCropY, g.width = Math.abs(c), g.height = n ? g.width / n : l) : "nw" === h && (g.x = e.startCropX + c, g.width = Math.abs(c), n ? (g.height = g.width / n, g.y = e.startCropY - g.height) : (g.height = Math.abs(l), g.y = e.startCropY + l));
            var w = p(g, n, h, t.width, t.height, o, r, i, a);
            return n || u.xyOrds.indexOf(d) > -1 ? (s.x = w.x, s.y = w.y, s.width = w.width, s.height = w.height) : u.xOrds.indexOf(d) > -1 ? (s.x = w.x, s.width = w.width) : u.yOrds.indexOf(d) > -1 && (s.y = w.y, s.height = w.height), s;
          }
        }, {
          key: "createCropSelection",
          value: function createCropSelection() {
            var _this2 = this;

            var _this$props9 = this.props,
                _this$props9$ariaLabe = _this$props9.ariaLabels,
                e = _this$props9$ariaLabe === void 0 ? u.defaultProps.ariaLabels : _this$props9$ariaLabe,
                n = _this$props9.disabled,
                o = _this$props9.locked,
                r = _this$props9.renderSelectionAddon,
                i = _this$props9.ruleOfThirds,
                a = _this$props9.crop,
                h = this.getCropStyle();
            if (a) return t().createElement("div", {
              style: h,
              className: "ReactCrop__crop-selection",
              onPointerDown: this.onCropPointerDown,
              "aria-label": e.cropArea,
              tabIndex: 0,
              onKeyDown: this.onComponentKeyDown,
              role: "group"
            }, !n && !o && t().createElement("div", {
              className: "ReactCrop__drag-elements",
              onFocus: this.onDragFocus
            }, t().createElement("div", {
              className: "ReactCrop__drag-bar ord-n",
              "data-ord": "n"
            }), t().createElement("div", {
              className: "ReactCrop__drag-bar ord-e",
              "data-ord": "e"
            }), t().createElement("div", {
              className: "ReactCrop__drag-bar ord-s",
              "data-ord": "s"
            }), t().createElement("div", {
              className: "ReactCrop__drag-bar ord-w",
              "data-ord": "w"
            }), t().createElement("div", {
              className: "ReactCrop__drag-handle ord-nw",
              "data-ord": "nw",
              tabIndex: 0,
              "aria-label": e.nwDragHandle,
              onKeyDown: function onKeyDown(e) {
                return _this2.onHandlerKeyDown(e, "nw");
              },
              role: "button"
            }), t().createElement("div", {
              className: "ReactCrop__drag-handle ord-n",
              "data-ord": "n",
              tabIndex: 0,
              "aria-label": e.nDragHandle,
              onKeyDown: function onKeyDown(e) {
                return _this2.onHandlerKeyDown(e, "n");
              },
              role: "button"
            }), t().createElement("div", {
              className: "ReactCrop__drag-handle ord-ne",
              "data-ord": "ne",
              tabIndex: 0,
              "aria-label": e.neDragHandle,
              onKeyDown: function onKeyDown(e) {
                return _this2.onHandlerKeyDown(e, "ne");
              },
              role: "button"
            }), t().createElement("div", {
              className: "ReactCrop__drag-handle ord-e",
              "data-ord": "e",
              tabIndex: 0,
              "aria-label": e.eDragHandle,
              onKeyDown: function onKeyDown(e) {
                return _this2.onHandlerKeyDown(e, "e");
              },
              role: "button"
            }), t().createElement("div", {
              className: "ReactCrop__drag-handle ord-se",
              "data-ord": "se",
              tabIndex: 0,
              "aria-label": e.seDragHandle,
              onKeyDown: function onKeyDown(e) {
                return _this2.onHandlerKeyDown(e, "se");
              },
              role: "button"
            }), t().createElement("div", {
              className: "ReactCrop__drag-handle ord-s",
              "data-ord": "s",
              tabIndex: 0,
              "aria-label": e.sDragHandle,
              onKeyDown: function onKeyDown(e) {
                return _this2.onHandlerKeyDown(e, "s");
              },
              role: "button"
            }), t().createElement("div", {
              className: "ReactCrop__drag-handle ord-sw",
              "data-ord": "sw",
              tabIndex: 0,
              "aria-label": e.swDragHandle,
              onKeyDown: function onKeyDown(e) {
                return _this2.onHandlerKeyDown(e, "sw");
              },
              role: "button"
            }), t().createElement("div", {
              className: "ReactCrop__drag-handle ord-w",
              "data-ord": "w",
              tabIndex: 0,
              "aria-label": e.wDragHandle,
              onKeyDown: function onKeyDown(e) {
                return _this2.onHandlerKeyDown(e, "w");
              },
              role: "button"
            })), r && t().createElement("div", {
              className: "ReactCrop__selection-addon",
              onMouseDown: function onMouseDown(e) {
                return e.stopPropagation();
              }
            }, r(this.state)), i && t().createElement(t().Fragment, null, t().createElement("div", {
              className: "ReactCrop__rule-of-thirds-hz"
            }), t().createElement("div", {
              className: "ReactCrop__rule-of-thirds-vt"
            })));
          }
        }, {
          key: "makePixelCrop",
          value: function makePixelCrop() {
            var e = _objectSpread(_objectSpread({}, i), this.props.crop || {}),
                t = this.getBox();

            return l(e, t.width, t.height);
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props10 = this.props,
                e = _this$props10.aspect,
                o = _this$props10.children,
                r = _this$props10.circularCrop,
                i = _this$props10.className,
                a = _this$props10.crop,
                h = _this$props10.disabled,
                s = _this$props10.locked,
                d = _this$props10.style,
                c = _this$props10.ruleOfThirds,
                _this$state = this.state,
                l = _this$state.cropIsActive,
                p = _this$state.newCropIsBeingDrawn,
                g = a ? this.createCropSelection() : null,
                w = function () {
              for (var e, t, o = 0, r = ""; o < arguments.length;) {
                (e = arguments[o++]) && (t = n(e)) && (r && (r += " "), r += t);
              }

              return r;
            }("ReactCrop", i, {
              "ReactCrop--active": l,
              "ReactCrop--disabled": h,
              "ReactCrop--locked": s,
              "ReactCrop--new-crop": p,
              "ReactCrop--fixed-aspect": a && e,
              "ReactCrop--circular-crop": a && r,
              "ReactCrop--rule-of-thirds": a && c,
              "ReactCrop--invisible-crop": !this.dragStarted && a && !a.width && !a.height
            });

            return t().createElement("div", {
              ref: this.componentRef,
              className: w,
              style: d
            }, t().createElement("div", {
              ref: this.mediaRef,
              className: "ReactCrop__child-wrapper",
              onPointerDown: this.onComponentPointerDown
            }, o), g);
          }
        }]);

        return u;
      }(e.PureComponent);

      u.xOrds = ["e", "w"], u.yOrds = ["n", "s"], u.xyOrds = ["nw", "ne", "se", "sw"], u.nudgeStep = 1, u.nudgeStepMedium = 10, u.nudgeStepLarge = 100, u.defaultProps = {
        ariaLabels: {
          cropArea: "Use the arrow keys to move the crop selection area",
          nwDragHandle: "Use the arrow keys to move the north west drag handle to change the crop selection area",
          nDragHandle: "Use the up and down arrow keys to move the north drag handle to change the crop selection area",
          neDragHandle: "Use the arrow keys to move the north east drag handle to change the crop selection area",
          eDragHandle: "Use the up and down arrow keys to move the east drag handle to change the crop selection area",
          seDragHandle: "Use the arrow keys to move the south east drag handle to change the crop selection area",
          sDragHandle: "Use the up and down arrow keys to move the south drag handle to change the crop selection area",
          swDragHandle: "Use the arrow keys to move the south west drag handle to change the crop selection area",
          wDragHandle: "Use the up and down arrow keys to move the west drag handle to change the crop selection area"
        }
      };
    }(), r;
  }();
});